export default "__VITE_ASSET__BHh9ysWz__"